import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ReactPlayer from "react-player"; // or iframe
var getYouTubeId = function (url) {
    var match = url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/))([\w-]{11})/);
    return match ? match[1] : null;
};
export var TripGallery = function (_a) {
    var galleryImages = _a.galleryImages, videoUrl = _a.videoUrl;
    return (_jsxs("div", { className: "grid grid-cols-2 md:grid-cols-3 gap-4", children: [galleryImages && galleryImages.length > 0 && galleryImages.map(function (image, index) {
                return (_jsx("img", { src: image, alt: "Gallery item ".concat(index + 1), className: "rounded-lg w-full h-48 object-cover" }, index));
            }), videoUrl && _jsx("div", { className: "aspect-video rounded-lg overflow-hidden", children: _jsx(ReactPlayer, { src: videoUrl, width: "100%", height: "360px", controls: true }) })] }));
};
